export const FILTERS = {
  ALL: {
    label: 'All',
    value: 'all',
  },
  MANAGE: {
    label: 'Manage',
    value: 'manage',
  },
  ASSET: {
    label: 'My Team',
    value: 'asset',
  },
  KNOWLEDGE: {
    label: 'Knowledge',
    value: 'knowledge',
  },
  MARKETPLACE: {
    label: 'Marketplace',
    value: 'marketplace',
  },
  SERVICES: {
    label: 'Services',
    value: 'services'
  }
} as const;

export const PAGE_SIZE = 5;
export const PAGE_SIZE_MANAGE_FILTER = 10;

export const TICKET_TYPES = {
  APPROVALS: 'approvals',
  INCIDENTS: 'incidents',
  REQUESTS: 'requests',
};

export enum TICKET_STATUS {
  OPEN = "open",
  CLOSED = "closed",
  RESOLVED = "resolved",
};